import React from "react";
import { string } from "prop-types";

import { agentMatchItemPropType } from "../../../../propTypes";
import AgentStats from "../AgentStats";
import * as S from "./styled";

const AgentCard = ({ agentMatchItem, className }) => (
  <div className={className} data-qa="agent-card">
    <S.AgentDescription
      agentImageSrc={agentMatchItem.photoUrl}
      agentName={agentMatchItem.name}
      brokerage={agentMatchItem.brokerage}
      isPro={agentMatchItem.isPro}
    />
    <AgentStats
      medianSalesPrice={agentMatchItem.medianSalesPrice}
      nearbyHomes={agentMatchItem.homesSoldNearby}
      recentHomesSold={agentMatchItem.homesSoldRecent}
      similarHomes={agentMatchItem.homesSoldSimilar}
      soldHomesInUserBuilding={agentMatchItem.hasSoldInBuilding}
      yearsExperience={agentMatchItem.yearsExperience}
    />
  </div>
);

AgentCard.propTypes = {
  className: string,
  agentMatchItem: agentMatchItemPropType.isRequired
};

AgentCard.defaultProps = {
  className: null
};

export default AgentCard;
